import { NavLink } from "react-router";
import { Ansicht } from "./Ansicht";
import { Knopf } from "./Kachel";
import { useKopfziele } from "./Kopfnavigation";
import { Symbol } from "./Symbol";
import { useZurueck } from "./zurueck";

/**
 * Ansicht „mehr“ ohne Drückjagd (oberflaeche.md §1.6 Nr. 5 V-26, §3.1): `main` „mehr“ mit der Kopfnavigation `navigation`
 * „Navigation“ und allen Zielen als `link` (Referenz `#s-mehr` ohne Zustandsband), „Zurück“ fest unten. Eine eigene Ansicht
 * statt eines Dialogs: ein Dialog mit Kacheln fester Höhe blieb in Safari (iOS 16.4, 17.3) flach, „Schließen“ lag über den
 * Zielen (Gerätetest G2).
 */
export function MehrOhneDrueckjagd() {
  const ziele = useKopfziele();
  const zurueck = useZurueck("/");
  return (
    <Ansicht name="mehr" ohneKopf unten={<Knopf art="planung-zweit" onPress={zurueck}>Zurück</Knopf>}>
      <nav className="gruppe" aria-label="Navigation">
        {ziele.map(([pfad, begriff, symbol]) => (
          <NavLink key={pfad} to={pfad} end={pfad === "/"} className="k k--quer" aria-label={begriff}>
            <Symbol name={symbol} />
            <span className="k__b">{begriff}</span>
          </NavLink>
        ))}
      </nav>
    </Ansicht>
  );
}
